import React from 'react';
import { ArrowForward } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';
import { getHostCURL, getImageURL } from '../../../../common/utils/CardUtils';
import { analyticsStash } from '../../../../common/utils/AnalyticsUtils';

const eliteSupportLine = 'Elite Support Line';

export const OffersCardTile = (props) => {
  const {
    imageURL,
    imageClass,
    analyticsMessage,
    analyticsLinks,
    refLink,
    altText,
    linkText,
    children,
  } = props;

  let imgClass = imageClass || '';
  const imgSrc = imageURL && (imageURL.startsWith('http://') || imageURL.startsWith('https://'))
    ? imageURL
    : getImageURL(imageURL);
  const icon = (
    <div className={`${imgClass} sui-size-12`}>
      <img className="sui-min-w-12 sui-min-h-12" src={imgSrc} width="48px" height="48px" alt={altText} />
    </div>
  );

  let linkURL = getHostCURL(refLink);
  if (altText === eliteSupportLine) {
    linkURL = refLink;
  }

  return (
    <OffersCardTileDynamicIcon
      icon={icon}
      analyticsMessage={analyticsMessage}
      analyticsLinks={analyticsLinks}
      refLink={linkURL}
      linkText={linkText}
    >
      {children}
    </OffersCardTileDynamicIcon>
  );
};

export const OffersCardTileDynamicIcon = (props) => {
  const {
    analyticsMessage, analyticsLinks, refLink, icon, linkText, children
  } = props;

  return (
    <div className="sui-w-full">
      <a
        className="sui-inline-flex sui-no-underline sui-flex-row sui-justify-between sui-w-full sui-px-0 sui-my-4"
        href={refLink}
        rel=" noreferrer"
        onClick={() => analyticsMessage && analyticsStash('welcomeCard', analyticsMessage, analyticsLinks)}
      >
        {icon}
        <div className="sui-flex sui-flex-col sui-justify-center sui-items-start sui-mx-3 sui-w-full sui-pb-2">
          {children}
          <Typography variant="body-base" weight="regular" height="tight" decoration="underline">
            {linkText}
          </Typography>
        </div>
        <div className="sui-flex sui-flex-row sui-justify-end sui-items-center sui-pr-0">
          <ArrowForward size="small" />
        </div>
      </a>
    </div>
  );
};
